import type {
  ProductFormLocation,
  ProductFormValues,
  ProductRoutingMode,
} from '@up2stay/up2promo-commons/products';
import type { ReactNode } from 'react';

import type { ProductsDict } from '@/routes/app/products/products.types';

export type ProductFormFieldsProps = {
  values: ProductFormValues;
  onChange: (patch: Partial<ProductFormValues>) => void;
  knownProductType?: string | null;
  workspaceId?: string;
  locations: ProductFormLocation[];
  dict: ProductsDict | undefined;
  idPrefix?: string;
  showDescriptionHint?: boolean;
  descriptionRequiredMessage?: string;
  locationRequiredMessage?: string;
  descriptionFirst?: boolean;
  /** When set, overrides inferred routing mode (e.g. setup/claim wizard submit). */
  routingMode?: ProductRoutingMode;
  onRoutingModeChange?: (mode: ProductRoutingMode) => void;
  /** Inline validation messages from react-hook-form / zod. */
  fieldErrors?: {
    description?: string;
    targetUrl?: string;
  };
  onTargetUrlBlur?: () => void;
  onTargetUrlFocus?: () => void;
  onDescriptionBlur?: () => void;
  onDescriptionFocus?: () => void;
  /** When true, profile routing is locked to the current user (self-service BC linking). */
  hideProfileUserPicker?: boolean;
  lockedProfileUserLabel?: string;
  /** Opens nested / inline location create when the product needs a location. */
  onCreateLocation?: () => void;
  createLocationLabel?: string;
  noLocationsTitle?: string;
  noLocationsDescription?: string;
  /** Optional identity chrome (hash / autosave) merged into the first settings group. */
  leading?: ReactNode;
};

export const ROUTING_MODE_I18N_KEYS: Record<
  ProductRoutingMode,
  keyof NonNullable<NonNullable<ProductsDict['edit']>['routing']> | 'behaviour'
> = {
  profile: 'routingProfile',
  location: 'routingLocation',
  instagramUsername: 'routingInstagramUsername',
  tiktokUsername: 'routingTiktokUsername',
  customUrl: 'routingCustomUrl',
  behaviourSelect: 'behaviour',
};
